import { render, staticRenderFns } from "./cancel_result.vue?vue&type=template&id=31d93732&scoped=true&"
import script from "./cancel_result.vue?vue&type=script&lang=js&"
export * from "./cancel_result.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d93732",
  null
  
)

export default component.exports